export default __webpack_public_path__ + "static/char-s-01-en-401c9ae06a2faf44f8ae9252e42d9af2.png";